import React from 'react';
import { connect } from 'react-redux';


const FooterVariablePositives = ({nameProduct, comment}) => {
  return (
<div className='wrapper-repeated-information'>
  { nameProduct.toUpperCase() === 'ABROAD' ? (
    <div className='repeated-information-title'>*הסכומים פטורים ממע"מ</div>
  ) : nameProduct.toUpperCase() === 'ENERGY' ? (
     comment ? <div className='repeated-information-title'>{comment}</div> : null
  ) : (
    <div className='repeated-information-title'>*הסכומים כוללים מע"מ</div>
  )}
</div>
  );
}

const mapStateToProps = (state) => {
  return {
    comment: state.personalAreaInvoicesPage?.invoicesInfo?.generalTab?.comment,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FooterVariablePositives);
